module.exports = __webpack_public_path__ + "static/media/chevron-square-up.5c276c6d.svg";